import { useApi } from '~/store/store'
import { ResetLoading } from '~/components'
import { useParams } from 'react-router-dom'
import React, { useCallback, useState, useEffect } from 'react'
import { ResetPasswordForm, SuccessfulResetPassword, ExpiredLink } from './components'

type ResetPasswordParams = {
  token: string,
  email: string
}

export const ResetPassword: React.FC = () => {
  const { token } = useParams<ResetPasswordParams>()

  const [isResetPasswordSuccessful, setIsResetPasswordSuccessful] = useState(false)

  const [validateResetPasswordToken, validateResetPasswordTokenState] = useApi('validateResetPasswordToken')
  const { error, loading } = validateResetPasswordTokenState

  const validateToken = async () => {
    await validateResetPasswordToken({ token })
  }

  useEffect(() => {
    validateToken()
  }, [])

  const onSuccessfulResetPassword = useCallback(() => {
    setIsResetPasswordSuccessful(true)
  }, [])

  if (loading) {
    return <ResetLoading />
  }

  if (error) {
    return <ExpiredLink />
  }

  if (isResetPasswordSuccessful) {
    return <SuccessfulResetPassword />
  }

  return <ResetPasswordForm onSuccessfulResetPassword={onSuccessfulResetPassword} />
}
